import React from 'react';
import { useNavigate } from 'react-router';

import List from '@mui/material/List';
import Box from '@mui/material/Box';
import  Divider  from '@mui/material/Divider';

import SidebarItem from "./SidebarItem";

import BuchungenIcon from "./../../Assets/Icons/Buchungen.svg"
import KundenIcon from "./../../Assets/Icons/Kundenlogo.svg"
import PaketeIcon from "./../../Assets/Icons/Pakete.svg"
import EinstellungenIcon from "./../../Assets/Icons/Einstellungen.svg"
import StatistikenIcon from "../../Assets/Icons/Statistiken.svg"
import GutscheineIcon from "./../../Assets/Icons/Gutscheine.svg"
import Rechnungen from "./../../Assets/Icons/Rechnungen.svg"
import Admin from "./../../Assets/Icons/Frame 2147224918.svg"
import Main_Logo from "./../../Assets/Imgs/Main_Logo.png"
import logout from "./../../Assets/Icons/Logout.svg"

import { MdOutlineCalendarMonth } from "react-icons/md";
import { RiShoppingBag3Line } from "react-icons/ri";
import { MdDashboard } from "react-icons/md";

const SidebarItems = () => {
  const navigate = useNavigate()

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    navigate('/adminlogin');
    window.location.reload();
  };
  return(
    <Box>
      <img 
        src={Main_Logo } 
        alt="Main_Logo "
        style={{
          height:"150px",
          width:"150px",
          objectFit:"cover",
          marginInline:"auto",
          display:"flex",
          marginTop:"20px"
          }} 
      />
      <List 
        sx={{
          marginTop:"20px"
        }}>
        <SidebarItem 
          href= "/"
          title= "Dashboard"
          Icon= {<MdDashboard size={24}/>}
        />
        <SidebarItem 
          href= "/Reservations"
          title= "Buchungen"
          icon= {BuchungenIcon}
        />
        <SidebarItem 
          href= "/calendar"
          title= "Kalender"
          Icon= {<MdOutlineCalendarMonth size={24}/>}
        />
        <SidebarItem 
          href= "/Kunden"
          title= "Kunden"
          icon= {KundenIcon}
        />
        <SidebarItem 
          href= "/Pakete"
          title= "Pakete"
          icon= {PaketeIcon}
        />
        <SidebarItem 
          href= "/Gutscheine&Geschenke"
          title= "Gutscheine & Geschenke"
          icon= {GutscheineIcon}
        />
        <SidebarItem 
          href= "/ExtraObjects"
          title= "Extras"
          Icon= {<RiShoppingBag3Line size={24}/>}
        />
        <SidebarItem 
          href= "/Statistiken"
          title= "Statistiken"
          icon= {StatistikenIcon}
        />
        <SidebarItem 
          href= "/Einstellungen"
          title= "Einstellungen"
          icon= {EinstellungenIcon}
        />
        <SidebarItem 
          href= "/AdminVerwaltung"
          title= "Admin-Verwaltung"
          icon= { Admin }
        />
        <SidebarItem 
          href= "/Rechnungen"
          title= "Rechnungen"
          icon= { Rechnungen}
        />
        <Box mt={4}>
          <Divider sx={{mb:1}}/>
          <SidebarItem 
            onClick={handleLogout}
            title= "Abmelden"
            icon= { logout}
          />
        </Box>
        
      </List>
    </Box> 
  )
}

export default SidebarItems